<template>
    <v-container fluid fill-height>
        <v-card  outlined width="100%" class="fill-height">
            <v-card-text class="pa-5">
                <v-row>
                    <v-col cols=6 md=6 lg=6 sm=6>
                        <v-chip label color="amber"> <v-icon left>mdi-cube-outline</v-icon>Report Manager</v-chip>
                    </v-col>
                    <v-col cols=6 md=6 lg=6 sm=6 style="postion:relative">
                        
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=12>
                        <v-toolbar height=150>
                            <v-autocomplete label="Select Product" outlined :items="products" color="amber"
                            multiple item-text="name" item-value="id" v-model="product" dense hide-details>
                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index === 0"><span>{{ item.name }}</span></v-chip>
                                    <span v-if="index === 1" class="grey--text caption">(+{{ product.length - 1 }} others)</span>
                                </template>                            
                            </v-autocomplete>
                            <v-spacer></v-spacer>
                            <v-menu ref="fromdateMenu" v-model="fromdateMenu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field label="Start" prepend-icon="mdi-calendar-range" outlined v-model="fromdate"
                                    color="amber" readonly v-on="on" dense hide-details></v-text-field>
                                </template>
                                <v-date-picker color="amber" v-model="fromdate" scrollable :max="new Date().toISOString().substr(0, 10)" ></v-date-picker>
                            </v-menu>
                            <v-spacer></v-spacer>
                            <v-menu ref="todateMenu" v-model="todateMenu" :close-on-content-click="true" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field prepend-icon="mdi-calendar-range" outlined label="End" v-model="todate" color="amber"
                                    readonly v-on="on" dense hide-details></v-text-field>
                                </template>
                                <v-date-picker color="amber" v-model="todate" scrollable :max="new Date().toISOString().substr(0, 10)" ></v-date-picker>
                            </v-menu>
                            <v-spacer></v-spacer>
                            <v-btn color="amber" @click="fetchrecord">Fetch Data</v-btn>
                        </v-toolbar>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=12 md=12 lg=12 sm=12>
                        <v-btn color="success" v-if="records.length > 0" @click="exportexcelfile()">download</v-btn>
                        <v-data-table :headers="headers" :items="records" :search="search" :expanded.sync="expanded" show-expand class="parent-setting">
                            <template v-slot:expanded-item="{ item }" :colspan="headers.length">
                                <td :colspan="headers.length+1" class="ma-0 pa-0">
                                    <v-card color="red" tile flat>
                                     <v-data-table class="icon-setting" :items="child(item.id)[0]"  dark 
                                     :headers="localheaders" hide-default-footer 
                                     hide-default-header show-expand expand-icon="mdi-record-circle-outline"></v-data-table>
                                    </v-card>
                                </td>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row> 
            </v-card-text>           
        </v-card>
    </v-container>
</template>
<script>
import { SERVER_API } from '../API';
import Excel from 'exceljs';
 import Filesaver from 'file-saver';
export default {
    mounted(){
        this.fetchall();
    },
    data(){
        return{
            expanded: [],
            singleExpand: false,
            search:'',
            fromdate:'',
            todate:'',
            fromdateMenu:false,
            todateMenu:false,
            product:[],
            records:[],
            localheaders:[
                { text: 'Date', value:'createDate'},
                { text: 'Bargin No', value:'orderId'},
                { text: 'Party Name', value:'partyName'},
                { text: 'Location', value:'partyLocation'},
                { text: 'Item', value:'product'},
                { text: 'Qty/Tons.', value:'qty'},
                { text: 'Rate/Qtl.', value:'partyRate'},
                { text: 'Condition', value:'partyCon'},
                { text: 'OrderType', value:'partyOrderTy'},
                { text: 'Final Date', value:'finalDate'},
                { text: 'Broker', value:'broker'}
            ],
            headers:[
                { text: 'Date', value: 'orderDate' },
                { text: 'Bargin No', value: 'bargainNo' },
                { text: 'Party Name', value: 'partyName' },
                { text: 'Location', value: 'location' },
                { text: 'Item', value: 'product' },
                { text: 'Qty/Tons.', value: 'qty' },
                { text: 'Rate/Qtl.', value: 'rate' },
                { text: 'Condition', value: 'condition' },
                { text: 'OrderType', value: 'orderType' },
                { text: 'Final Date', value: 'finalDate' },
                { text: 'Broker', value: 'broker' },
            ],
            products:[],
        }
    },
    methods:{
        exportexcelfile(){
            var workbook = new Excel.Workbook();
            workbook.create = 'Test';
            workbook.lastModifiedBy = '';
            workbook.created = new Date(2018, 6, 19);
            workbook.modified = new Date();
            workbook.lastPrinted = new Date(2016, 9, 27);
            var sheet = workbook.addWorksheet('Records');
            sheet.columns = [
                { header: 'Date', key: 'createDate' },
                { header: 'Bargin No', key: 'bargainNo' },
                { header: 'Party Name', key: 'partyName' },
                { header: 'Location', key: 'location' },
                { header: 'Item ', key: 'item' },
                { header: 'Qty/Tons', key: 'qty' },
                { header: 'Rate/Qtl', key: 'rate' },
                { header: 'Condition', key: 'condition' },
                { header: 'OrderType', key: 'orderType' },
                { header: 'Final Date', key: 'finalDate' },
                { header: 'Broker', key: 'broker' },
            ]
            sheet.getRow(1).border = {
                top: {style:'thin', color: {argb:''}},
                left: {style:'thin', color: {argb:'000000'}},
                bottom: {style:'thin', color: {argb:'000000'}},
                right: {style:'thin', color: {argb:'000000'}}
            };
            sheet.getCell('A1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            sheet.getCell('B1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            sheet.getCell('C1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            sheet.getCell('D1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            sheet.getCell('E1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            sheet.getCell('F1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            sheet.getCell('G1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            sheet.getCell('H1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            sheet.getCell('I1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            sheet.getCell('J1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            sheet.getCell('K1').fill = {
                type: 'pattern',
                pattern:'darkTrellis',
                fgColor:{argb:'FFFFFF00'},
                bgColor:{argb:'FF0000FF'}
            };
            for(var i =0; i <= this.records.length-1;i++ ){              
                sheet.addRow({
                    createDate : this.records[i].orderDate,
                    bargainNo : this.records[i].bargainNo,
                    partyName : this.records[i].partyName,
                    location : this.records[i].location,
                    item : this.records[i].product,
                    qty : this.records[i].qty,
                    rate : this.records[i].rate,
                    condition : this.records[i].condition,
                    orderType : this.records[i].orderType,
                    finalDate : this.records[i].finalDate,
                    broker : this.records[i].broker,
                });
                if(this.records[i].orderparty.length > 0){
                    for(var j=0; j <= this.records[i].orderparty.length-1; j++ ){
                        //console.log(this.records[i].orderparty[j]);
                        sheet.addRow({
                            createDate : this.records[i].orderparty[j].createDate,
                            bargainNo : this.records[i].orderparty[j].orderId,
                            partyName : this.records[i].orderparty[j].partyName,
                            location : this.records[i].orderparty[j].partyLocation,
                            item : this.records[i].orderparty[j].product,
                            qty : this.records[i].orderparty[j].qty,
                            rate : this.records[i].orderparty[j].partyRate,
                            condition : this.records[i].orderparty[j].partyCon,
                            orderType : this.records[i].orderparty[j].partyOrderTy,
                            finalDate : this.records[i].orderparty[j].finalDate,
                            broker : this.records[i].orderparty[j].broker,
                        });
                    }
                    sheet.addRow({
                        createDate : '-',
                        bargainNo : '-',
                        partyName : '-',
                        location : '-',
                        item : '-',
                        qty : '-',
                        rate : '-',
                        condition : '-',
                        orderType : '-',
                        finalDate : '-',
                        broker : '-',
                    });
                }
                /*for(var j=0; j <= this.child(this.records[i].id)[0].lenght-1; j++ ){
                    sheet.addRow({
                        createDate : this.child(this.records[i].id)[0][j].createDate,
                        bargainNo : this.child(this.records[i].id)[0][j].orderId,
                        partyName : this.child(this.records[i].id)[0][j].partyName,
                        location : this.child(this.records[i].id)[0][j].partyLocation,
                        item : this.child(this.records[i].id)[0][j].product,
                        qty : this.child(this.records[i].id)[0][j].qty,
                        rate : this.child(this.records[i].id)[0][j].partyRate,
                        condition : this.child(this.records[i].id)[0][j].partyCon,
                        orderType : this.child(this.records[i].id)[0][j].partyOrderTy,
                        finalDate : this.child(this.records[i].id)[0][j].finalDate,
                        broker : this.child(this.records[i].id)[0][j].broker,
                    });
                }*/
            }
            workbook.xlsx.writeBuffer()
            .then(buffer => Filesaver.saveAs(new Blob([buffer]), `${Date.now()}_monthly_report_order.xlsx`));
        },
        child(getdata){
            const response = [];
            for(let i = 0; i < this.records.length; i++){
                if(this.records[i].orderparty.length > 0){
                    const data = this.records[i].orderparty.filter((party) => party.order == getdata);
                    response.push(data);
                }
            }
            return response;
        },
        async fetchrecord(){
            const response =  await this.$http.post(SERVER_API+'/report/records',{
                fromdate: this.fromdate,
                todate: this.todate,
                product: this.product
            });
            this.records = response.data.data;
            //console.log(response.data);            
        },
        async fetchall(){
            const response =  await this.$http.get(SERVER_API+'/product/records');
            this.products = response.data.data;
        },
    }

}
</script>

<style>
.Speed-button-Setting{
    position:absolute;
    right:30px;
}
.icon-setting i {
    font-size: 12px !important;
    color:rgb(48, 241, 48) !important;
    cursor: default !important;
    margin-left:5px;
}
.icon-setting tr td:first-child{
    width:20px !important;
}
.icon-setting tr td{
    font-size: 11px !important;
}
.parent-setting tr td{ 
font-size: 13px ;
}
</style>